/**
 * The shadow an OmniLight3D or SpotLight3D declares to the scene's positional shadow fitter, with
 * Godot's class default for each property it leaves out.
 */
import { useMemo } from 'react';
import { LIGHT_3D_DEFAULTS } from '../../../../godot/scene/light';
import { positionalSoftShadow } from '../../../../godot/rendering/lights/positionalShadow';
import { positionalShadowUserData, } from '../../../../r3f/positionalShadow/declaration';
import { softShadowRadius } from '../../../../r3f/positionalShadow/softShadowRadius';
export function positionalShadowDeclaration(properties) {
    const softShadow = positionalSoftShadow(properties.light_size ?? LIGHT_3D_DEFAULTS.size, properties.shadow_blur ?? LIGHT_3D_DEFAULTS.shadowBlur);
    return {
        normalBias: properties.shadow_normal_bias ?? LIGHT_3D_DEFAULTS.shadowNormalBias,
        softShadowRadius: softShadowRadius(softShadow),
    };
}
/** The light's `userData`, rebuilt only when a property the declaration reads changes. */
export function usePositionalShadowUserData({ shadow_normal_bias, shadow_blur, light_size, }) {
    return useMemo(() => positionalShadowUserData(positionalShadowDeclaration({ shadow_normal_bias, shadow_blur, light_size })), [shadow_normal_bias, shadow_blur, light_size]);
}
//# sourceMappingURL=positionalShadowDeclaration.js.map